import PropTypes from 'prop-types';
import FJGenerateButton from '../../../common/components/FJGenerateButton/FJGenerateButton';
import styles from './FJMobileImageManipulationEdit.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
// import FJMobileArrow from '../../../assets/svg/mobile-arrow.svg?react';
import FJForbidIcon from '../../../assets/svg/forbid.svg?react';
import FJSwitchButton from '../../../common/components/FJSwitchButton/FJSwitchButton';
import FJHoverBoardGradation from '../../../common/components/FJHoverBoard/FJHoverBoardGradation';
import FJFileUpload from '../../../common/components/FJFileUpload/FJFileUpload';
import FJMobileFooterBox from '../../../common/components/FJMobileFooterBox/FJMobileFooterBox';
import { useState, useRef } from 'react';
import UploadIcon from '../../../assets/svg/upload-black.svg?react';
import FJButtonRightArrow from '../../../assets/svg/button-right.svg?react';
import classNames from 'classnames';
import FJUtil from '../../../util/FJUtil';
import FJMobileCreaseEditContainer from '../FJMobileCreaseEdit/FJMobileCreaseEdit.container';

const FJMobileImageManipulationEdit = props => {
    const {
        switchOldPhotoRestoration,
        switchPhotoColorize,
        onGenerate,
        taskStatus,
        freeNumCreation,
        creditNumber,
        isProjectLoading,
        imageEnhancerData = {},
        switchScratchOrFold,
        uploadImageInfo,
        uploadImg,
        onSwitchOldPhotoRestoration,
        onSwitchPhotoColorize,
        changeSwitchScratchOrFold,
        onChangeImageEnhancerData,
        photoColorizeNum,
        imageEnhancerNum,
        setIsCanDraw,
    } = props;
    const useCredit =
        (switchOldPhotoRestoration + switchPhotoColorize + imageEnhancerData.switch + switchScratchOrFold) * 2;
    const isFree = freeNumCreation > 0 && creditNumber < useCredit;
    const isDisabled = FJUtil.isGeneratingStatus(taskStatus);
    const [expandEdit, setExpandEdit] = useState(true);
    const scalerBoxRef = useRef(null);
    const creaseBoxRef = useRef(null);
    const _renderEditContent = () => {
        return (
            <div className={classNames(styles.edit_content, expandEdit ? styles.show : styles.hide)}>
                <div
                    className={classNames(
                        styles.edit_content_box,
                        (isDisabled || photoColorizeNum !== 0) && styles.disabled,
                    )}
                >
                    <div className={styles.edit_item_text}>{FJLocalStore._('colorizer')}</div>
                    <FJSwitchButton
                        type='gradient'
                        className={styles.switch}
                        active={switchPhotoColorize}
                        onChange={onSwitchPhotoColorize}
                    />
                </div>
                <div className={classNames(styles.edit_content_box, isDisabled && styles.disabled)}>
                    <div className={styles.edit_item_text}>{FJLocalStore._('restoration')}</div>
                    <FJSwitchButton
                        type='gradient'
                        className={styles.switch}
                        active={switchOldPhotoRestoration}
                        onChange={onSwitchOldPhotoRestoration}
                    />
                </div>
                <div
                    className={classNames(styles.edit_content_box, isDisabled && styles.disabled)}
                    onClick={e => {
                        FJUtil.forbidEvent(e);
                        !switchScratchOrFold && changeSwitchScratchOrFold(true);
                        creaseBoxRef.current.show();
                        setIsCanDraw(true);
                        setExpandEdit(false);
                    }}
                >
                    <div className={styles.edit_item_text}>{FJLocalStore._('remove-scratches')}</div>
                    <div className={styles.edit_switch}>
                        {switchScratchOrFold ? FJLocalStore._('on') : FJLocalStore._('off')}
                        <FJButtonRightArrow />
                    </div>
                </div>
                <div
                    className={classNames(
                        styles.edit_content_box,
                        (isDisabled || imageEnhancerNum !== 0) && styles.disabled,
                    )}
                    onClick={e => {
                        FJUtil.forbidEvent(e);
                        scalerBoxRef.current.show();
                        setExpandEdit(false);
                    }}
                >
                    <div className={styles.edit_item_text}>{FJLocalStore._('upscaler')}</div>
                    <div className={styles.edit_switch}>
                        {imageEnhancerData.switch ? imageEnhancerData.upscale + 'X' : FJLocalStore._('off')}
                        <FJButtonRightArrow />
                    </div>
                </div>
            </div>
        );
    };

    const _onUpScalerClick = index => {
        const newData = JSON.parse(JSON.stringify(imageEnhancerData));
        if (index === 0) {
            newData.switch = false;
        } else {
            newData.switch = true;
            newData.upscale = index;
        }
        onChangeImageEnhancerData(newData);
    };
    const _renderUpScalerFooterBox = () => {
        const { upscale, switch: imageEnhancerDataSwitch } = imageEnhancerData;
        const { src: imgSrc, width, height } = uploadImageInfo;

        const _isActive = idx => {
            if (imageEnhancerDataSwitch === false || idx === 0) {
                return imageEnhancerDataSwitch === false && idx === 0;
            } else return upscale === idx;
        };
        const imgPixelInfo = imgSrc ? `${Math.floor(width * upscale)} * ${Math.floor(height * upscale)} px` : '';
        return (
            <FJMobileFooterBox
                ref={scalerBoxRef}
                title={FJLocalStore._('upscale-size')}
                titleRight={<div className={styles.pixel_info}>{imgPixelInfo}</div>}
                iconType='ok'
                closeCallback={() => {
                    setExpandEdit(true);
                }}
            >
                <div className={styles.upscaler_box}>
                    {new Array(5).fill(0).map((item, index) => {
                        return (
                            <FJHoverBoardGradation
                                key={index}
                                contentClassName={styles.upscaler_item_content}
                                className={classNames(styles.upscaler_item, { [styles.active]: _isActive(index) })}
                                active={_isActive(index)}
                                onClick={() => {
                                    _onUpScalerClick(index);
                                }}
                                selectBgColor={'#fff'}
                            >
                                {index === 0 ? <FJForbidIcon /> : `${index}X`}
                            </FJHoverBoardGradation>
                        );
                    })}
                </div>
            </FJMobileFooterBox>
        );
    };
    const _renderCreaseFooterBox = () => {
        return (
            <FJMobileFooterBox
                ref={creaseBoxRef}
                autoClose={false}
                title={FJLocalStore._('remove-scratches')}
                closeCallback={() => {
                    setExpandEdit(true);
                    setIsCanDraw(false);
                }}
                iconType='ok'
                titleRight={
                    <FJSwitchButton type='gradient' active={switchScratchOrFold} onChange={changeSwitchScratchOrFold} />
                }
            >
                <FJMobileCreaseEditContainer />
            </FJMobileFooterBox>
        );
    };
    return (
        <div className={styles.container}>
            {/* <div
                className={styles.edit_header}
                onClick={() => {
                    setExpandEdit(!expandEdit);
                }}
            >
                <div className={styles.title}>{FJLocalStore._('image-settings')}</div>
                <FJMobileArrow className={!expandEdit ? styles.arrow_up : ''} />
            </div> */}
            {_renderEditContent()}
            <div className={styles.btn_box}>
                <FJFileUpload
                    className={classNames(styles.upload_box, isDisabled && styles.disabled)}
                    onUpload={uploadImg}
                >
                    <UploadIcon />
                </FJFileUpload>
                <FJGenerateButton
                    className={styles.generate_btn}
                    onClick={onGenerate}
                    taskStatus={taskStatus}
                    freeNumCreation={freeNumCreation}
                    isFree={isFree}
                    useCredit={useCredit}
                    isProjectLoading={isProjectLoading}
                />
            </div>
            {_renderUpScalerFooterBox()}
            {_renderCreaseFooterBox()}
        </div>
    );
};
FJMobileImageManipulationEdit.propTypes = {
    switchOldPhotoRestoration: PropTypes.bool,
    switchPhotoColorize: PropTypes.bool,
    onSwitchOldPhotoRestoration: PropTypes.func,
    onSwitchPhotoColorize: PropTypes.func,
    onGenerate: PropTypes.func,
    taskStatus: PropTypes.string,
    freeNumCreation: PropTypes.number,
    creditNumber: PropTypes.number,
    imageEnhancerData: PropTypes.object,
    isProjectLoading: PropTypes.bool,
    switchScratchOrFold: PropTypes.bool,
    photoColorizeNum: PropTypes.number,
    imageEnhancerNum: PropTypes.number,
    uploadImageInfo: PropTypes.object,
    uploadImg: PropTypes.func,
    changeSwitchScratchOrFold: PropTypes.func,
    onChangeImageEnhancerData: PropTypes.func,
    setIsCanDraw: PropTypes.func,
};
export default FJMobileImageManipulationEdit;
